import { useMemo } from "react";
import { required } from "../../../../../../helpers/forms/validate.js";
import useSearcherOriginInput from "../../../../../../hooks/common/searchers/inputs/useOriginInput.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../../context/index.js";
import useSearcherFlightHotelDefaultValues from "../../hooks/useSearcherFlightHotelDefaultValues.js";
const useOriginInput = ()=>{
    const props = useSearcherFlightHotelProps();
    const { origin , config  } = props ?? {};
    const { literals  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { isLoading  } = state ?? {};
    const defaultValues = useSearcherFlightHotelDefaultValues(props);
    const requiredValidation = useMemo(()=>[
            required()
        ], []);
    return useSearcherOriginInput({
        ...origin,
        types: origin?.types ?? [
            'AER'
        ],
        disabled: isLoading,
        validate: requiredValidation,
        label: literals?.originLabel ?? '',
        defaultValue: defaultValues.origin
    });
};
export default useOriginInput;

//# sourceMappingURL=useOriginInput.js.map